<script lang="ts">
  import type { HTMLAnchorAttributes } from 'svelte/elements';
  import type { HTMLProps } from 'svelte/svelte-html';

  export let props: HTMLProps<'a', HTMLAnchorAttributes> = {};

  $: href = props?.target === '_blank' ? props.href : `/${props?.href}`;
  // @TODO - improve href & target logic + paths
</script>

<a {...props} {href} on:click>
  <slot />
</a>
